import ApiClient from '@afosto/api/ApiClient';

class Invoices {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create invoice
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Create a new invoice
   * @returns {Promise}
   */
  createInvoice(body, options = {}) {
    return this.apiClient.request({
      url: `/odr/invoices`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Generate invoice
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Generate PDF invoice
   * @returns {Promise}
   */
  generatePdfInvoice(id, options = {}) {
    return this.apiClient.request({
      url: `/odr/invoices/${id}/print`,
      method: 'post',
      ...options,
    });
  }

  /**
   * List invoices
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.orderId]
   * @param {Object} options - The additional request options
   * @description Returns a list of invoices
   * @returns {Promise}
   */
  listInvoices(query = {}, options = {}) {
    const params = {
      order_id: query.orderId,
    };

    return this.apiClient.request({
      url: `/odr/invoices`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Mark paid
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Mark invoice as paid
   * @returns {Promise}
   */
  markPaid(id, body, options = {}) {
    return this.apiClient.request({
      url: `/odr/invoices/${id}/paid`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * View invoice
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Returns a single invoice by id
   * @returns {Promise}
   */
  viewInvoice(id, options = {}) {
    return this.apiClient.request({
      url: `/odr/invoices/${id}`,
      method: 'get',
      ...options,
    });
  }
}

export const invoices = new Invoices();

export default Invoices;
